import React, { Fragment, Component } from "react";
import { FormGroup, Row, Col } from "reactstrap";
import Autosuggest from "../../../../Autosuggest/Autosuggest";
import styleF from "../Field.module.scss";
import { CircularProgress } from "../../../..";
import Holders from "./Holders";
import Instruction from "./Instruction";
import { clientPrice, commissionSuffix } from "../../../Order/Form/commons";
import {
  OrderPriceType,
  getCommissionItems,
  ProductType,
  CommissionType as ComType,
  getBaseAndPriceCurrencies,
} from "../../../../../utils/Order/Order";
import { Field, Numeric, Combobox, Switch } from "../Field";
import QuantityHelper from "../../Helper/QuantityHelper";
import EarningsHelper from "../../Helper/EarningsHelper";
import Balance from "./Balance";
import { UserType } from "../../../../../utils/Helper";
import { Dispatch as Context } from "../../store/store";
import { formattedNumber } from "../../../../FormattedNumber/FormattedNumber";

class Account extends Component {
  constructor(props) {
    super(props);
    const { account, balanceReady } = props;
    const { AccountId } = account;

    Account.contextType = Context;

    this.state = {
      loadingHolders: AccountId != null,
      loadingBalance: AccountId != null && balanceReady,
      holders: null,
      balance: null,
      instructions: null,
      sendingMail: false,
    };
  }

  componentWillMount() {
    const { account } = this.props;
    const { AccountId } = account;

    if (AccountId != null) {
      this.requestAccountInfo();
      this.requestAccountHolders({ accountId: AccountId });
    }
  }

  componentDidMount() {
    this._isMounted = true;
    const { account } = this.props;
    const { AccountId, AccountName, AccountNumber, HolderId } = account;

    if (AccountId != null) {
      this.requestAccountInfo({}, false);
      this.requestAccountHolders({ accountId: AccountId });
    }

    // Cuando se ve una orden ya viene precargados los valores
    if (!isEmpty(AccountId) && isEmpty(HolderId)) {
      this.onChange("", {
        id: AccountId,
        name: AccountName,
        number: AccountNumber,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { account, balanceReady } = this.props;
    const { AccountId } = account;

    // Caso especifico cuando se elige el ticker del selector
    if (balanceReady && !prevProps.balanceReady && AccountId) {
      this.requestAccountInfo({}, true);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSuggestionsFetchRequested = ({ value }) =>
    this.props.searchAccount({ text: value }).then((response) =>
      response.response.accounts.map((a) => {
        const accountAttrs = JSON.parse(a.Value);

        return {
          id: a.Id,
          name: accountAttrs.value,
          number: accountAttrs.key,
        };
      })
    );

  onChangeAccountHolder = (value) => {
    const holderItem = getItemById(this.state.holders, value);

    let currentInstruction = -1;
    if (this.props.order.CurrentAccount) {
      currentInstruction = this.props.order.CurrentAccount.Instruction;
      if (holderItem.instructions.find((ins) => ins.id == currentInstruction) === undefined) {
        // If the current instruction is not available to the new holder,
        // select the first instruction available to the holder.
        currentInstruction = holderItem.instructions[0].id;
      }
    }

    this.setState({
      instructions: holderItem.instructions,
    });

    this.props.onChange({
      HolderId: holderItem.id,
      HolderName: holderItem.description,
      Instruction: currentInstruction,
    });
  };

  onChangeInstruction = (value) => {
    const instructionItem = getItemById(this.state.instructions, value);

    this.props.onChange({
      Instruction: instructionItem.id,
    });
  };

  requestAccountInfo = (body, updateOrderValues) => {
    if (this.props.balanceReady) {
      const assetTicker = this.props.order.AssetTicker;

      this.setState({ loadingBalance: true });

      this.props.accountInfo({ ...body }, updateOrderValues).then((response) => {
        const { balance, accountInfo } = response.response.accountorderdata;
        const { AccountAsksCustody, AccountType, AccountInBalanceType, AccountUseMarkUP } = accountInfo;

        const assetBalanceItem = balance.find((item) => item.key == assetTicker);
        const assetBalance = assetBalanceItem ? parseFloat(assetBalanceItem.value) : 0.0;

        let modsOnAccount = {
          AccountAsksCustody,
          AccountType,
          AccountInBalanceType,
          AccountAssetBalance: assetBalance,
          AccountUseMarkUP,
        };
        if (AccountAsksCustody) {
          modsOnAccount.RequiresSpecialCustody = true;
        }

        if (this._isMounted) {
          this.setState({
            balance,
            loadingBalance: false,
          });
          this.props.onChange(modsOnAccount);
        }
      });
    }
  };

  requestAccountHolders = ({ accountId }) => {
    this.props.accountHolders({ accountId }).then((response) => {
      const { holders } = response.response;

      const _holders = holders
        .filter((h) => h.HoldersOrderNO || h.HoldersOrderW || h.HoldersOrderV || h.HoldersOrderL)
        .map((h) => ({
          isMain: h.IsMain,
          description: h.PersonName,
          instructions: getInstructions(h),
          id: h.PersonId,
        }));

      let selectedHolder = _holders.find((h) => h.isMain) || (_holders.length ? _holders[0] : null);

      if (this.props.order.CurrentAccount && this.props.order.CurrentAccount.HolderId > 0) {
        selectedHolder = _holders.find((h) => h.id == this.props.order.CurrentAccount.HolderId);
        if (selectedHolder === undefined) {
          selectedHolder = null;
        }
      }

      this._isMounted &&
        this.setState(
          {
            holders: _holders,
            loadingHolders: false,
            instructions: selectedHolder && selectedHolder.instructions,
          },
          () => {
            const { account } = this.props;
            const { HolderId } = account;

            if (HolderId == null && selectedHolder) {
              const { id, description, instructions } = selectedHolder;

              const instruction = instructions && instructions.length ? instructions[0] : null;

              this.props.onChange({
                HolderId: id,
                HolderName: description,
                Instruction: instruction ? instruction.description : null,
              });
            }
          }
        );
    });
  };

  onChange = (method, value) => {
    let _value = defaultAccountValue;

    if (method != "type" && value.id) {
      _value = {
        AccountNumber: value.number,
        AccountName: value.name,
        AccountId: value.id,
      };

      this.requestAccountInfo(_value, true);
      this.requestAccountHolders({ accountId: value.id });
      this.setState({ holders: null, balance: null, loadingHolders: true });
    } else {
      this.setState({ holders: null, balance: null, instructions: null });
      _value.AccountName = value;
    }

    this.props.onChange(_value);
  };

  onSetAttachment = (file) => {
    const { dispatch, account } = this.props;
    const { AccountId } = account;
    dispatch({ type: "SET_ATTACHMENT", payload: { id: AccountId, file } });
  };

  onResendAuth = (orderId, accountId) => {
    this.setState({ sendingMail: true });
    this.props.resendAuth(orderId, accountId);
    setTimeout(() => {
      this.setState({ sendingMail: false });
    }, 1000);
  };

  render() {
    const {
      order,
      account,
      readonly,
      hiddens,
      errors,
      balanceReady,
      attachContent,
      downloadAttachment,
      orderPdf,
      attachmentDisabled,
      hasAttachment,
      onChange,
      userType,
    } = this.props;
    const {
      AccountId,
      AccountName,
      AccountNumber,
      AccountType,
      HolderId,
      HolderName,
      Quantity,
      AccountAsksCustody,
      RequiresSpecialCustody,
      AccountUseMarkUP,
      Markup,
      MarkupType,
      FXMarkup,
      FXMarkupType,
      Commission,
      CommissionType,
      CurrentInfoDate,
    } = order.CurrentAccount;
    const {
      OrderId,
      OrderSide,
      AssetClassForm,
      AssetPriceIsDiscounted,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol,
      AssetCanBeSelfCustodied,
      OrderQuantityIsCash,
      SubAssetClassDecimalPlaces,
      OrderAllowsMarkup,
    } = order;
    const { state: contextState } = this.context;
    const { entities: contextEntities } = contextState;
    const { settlementCurrencies } = contextEntities;

    const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
      settlementCurrencies,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol
    );

    let custodyHidden = false;
    let markupHidden = false;
    let FXMarkupHidden = false;
    let commissionHidden = false;
    let custodyReadonly = false;
    if (
      (!AccountType && userType === UserType.Trader) ||
      (AccountType && AccountType.toLowerCase() !== "customer")
    ) {
      custodyHidden = true;
      markupHidden = true;
      FXMarkupHidden = true;
      commissionHidden = true;
    } else {
      switch (AssetClassForm) {
        case ProductType.FOREX:
          markupHidden = true;
          FXMarkupHidden = true;
          commissionHidden = true;
          break;
        case ProductType.MMARKET:
          FXMarkupHidden = true;
          break;
        default:
          break;
      }
      if (!OrderSettlementCurrencySymbol || OrderCurrencySymbol == OrderSettlementCurrencySymbol) {
        FXMarkupHidden = true;
      }
      if (OrderSide == "Buy" && AssetCanBeSelfCustodied) {
        custodyHidden = false;
        if (AccountAsksCustody) {
          custodyReadonly = true;
        }
      } else {
        custodyHidden = true;
      }
    }

    if ((OrderId && OrderAllowsMarkup === false) || AccountUseMarkUP === false) {
      markupHidden = true;
      FXMarkupHidden = true;
    }

    const modHiddens = {
      ...hiddens,
      RequiresSpecialCustody: custodyHidden,
      Markup: markupHidden,
      MarkupType: markupHidden,
      FXMarkup: FXMarkupHidden,
      FXMarkupType: FXMarkupHidden,
      Commission: commissionHidden,
      CommissionType: commissionHidden,
    };

    const currentDay = account.Day
      ? account.Day.find((day) => day.Date == CurrentInfoDate)
      : {
          AssignedQty: 0,
          ExecutionsAvgPrice: 0,
          ExecutionsAvgFX: 0,
          Status: "New",
        };

    const currentDayIsReadOnly = currentDay.Status == "Booked";

    const isExistingAccount = order.Accounts
      ? !!order.Accounts.find((acc) => acc.index === account.index)
      : false;

    let modReadonly = {
      ...readonly,
      RequiresSpecialCustody: readonly.RequiresSpecialCustody || custodyReadonly,
      Markup: readonly.Markup || currentDayIsReadOnly,
      MarkupType: readonly.MarkupType || currentDayIsReadOnly,
      FXMarkup: readonly.FXMarkup || currentDayIsReadOnly,
      FXMarkupType: readonly.FXMarkupType || currentDayIsReadOnly,
      Commission: readonly.Commission || currentDayIsReadOnly,
      CommissionType: readonly.CommissionType || currentDayIsReadOnly,
      AccountName: readonly.AccountName || isExistingAccount,
    };

    const userIsOwner =
      !AccountType ||
      AccountType == "" ||
      (userType == UserType.Trader && AccountType != "Customer") ||
      (userType == UserType.Advisor && AccountType == "Customer");

    if (!userIsOwner) {
      Object.keys(order.CurrentAccount).forEach((key) => {
        modReadonly[key] = true;
      });
    }

    let canResend = false;
    if (order.canResendAuthorizations) {
      if (account.Instruction === "ViaLink") {
        canResend = true;
      }
    }

    const hideHolders =
      (userType == UserType.Trader && AccountType != "Customer") ||
      (this.state.holders !== null && this.state.holders.length == 0);

    let quantities = [];
    let quantityTitle = <span>Quantity</span>;
    let markupTitle = <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let FXMarkupTitle = <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>;
    let commissionTitle = <span>Commission</span>;
    let isPartiallyBooked = false;
    if (account.Day) {
      quantities = account.Day.map((day) => {
        if (day.Status == "Booked") {
          // If account is booked at least for one day, then:
          // - We can't change the account.
          isPartiallyBooked = true;
        }
        return {
          date: day.Date,
          status: day.Status,
          quantity: parseFloat(day.AssignedQty),
          markup: parseFloat(day.Markup),
          markupType: day.MarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          FXMarkup: parseFloat(day.FXMarkup),
          FXMarkupType: day.FXMarkupType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
          commission: parseFloat(day.Commission),
          commissionType: day.CommissionType == ComType.FaceValueCash ? "$ Cash" : "% Principal",
        };
      });
    }
    quantityTitle = (
      <Fragment>
        <span>Quantity</span>
        {quantities.length > 0 && OrderId > 0 && (
          <QuantityHelper quantities={quantities} name="account">
            <i className="icon-info icons" />
          </QuantityHelper>
        )}
      </Fragment>
    );
    markupTitle = (
      <Fragment>
        <span>{`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper quantities={quantities} earningCategoryName="markup" earningTypeName="markupType">
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    FXMarkupTitle = (
      <Fragment>
        <span>{`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}</span>
        {quantities.length > 0 && OrderId > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="FXMarkup"
            earningTypeName="FXMarkupType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );
    commissionTitle = (
      <Fragment>
        <span>Commission</span>
        {quantities.length > 0 && (
          <EarningsHelper
            quantities={quantities}
            earningCategoryName="commission"
            earningTypeName="commissionType"
          >
            <i className="icon-info icons" />
          </EarningsHelper>
        )}
      </Fragment>
    );

    if (isPartiallyBooked) {
      modReadonly = {
        ...modReadonly,
        AccountName: true,
        HolderName: true,
        Instruction: true,
        RequiresSpecialCustody: true,
        Quantity: true,
      };
    }

    const inputProps = {
      placeholder: "Account",
      disabled: modReadonly.AccountName,
      invalid: !!errors.AccountName,
    };

    const hasDifferentCurrencies = OrderCurrencySymbol !== OrderSettlementCurrencySymbol;

    const earningsTitle = `Values for ${CurrentInfoDate} (Q: ${formattedNumber(
      currentDay.AssignedQty,
      "quantity"
    )}; P: ${formattedNumber(currentDay.ExecutionsAvgPrice, "price")}${
      hasDifferentCurrencies
        ? `; FX [${baseCurrency}/${priceCurrency}]: ${formattedNumber(
            currentDay.ExecutionsAvgFX,
            "currency"
          )}`
        : ""
    }):`;

    let defaultMaxDecimals = 2;
    switch (order.AssetClassForm) {
      case ProductType.BOND:
      case ProductType.EQUITY:
      case ProductType.OPTION:
        defaultMaxDecimals = 0;
        break;
      case ProductType.MFUNDS:
      case ProductType.MMARKET:
        defaultMaxDecimals = 5;
        break;
      case ProductType.FOREX:
        defaultMaxDecimals = 2;
        break;
      default:
        defaultMaxDecimals = 2;
    }

    const quantityMaxDecimals = OrderQuantityIsCash ? 2 : SubAssetClassDecimalPlaces || defaultMaxDecimals;

    const showClientPrice =
      [OrderPriceType.LIMIT, OrderPriceType.STOPLIMIT].includes(order.OrderType) ||
      currentDay.ExecutionsAvgPrice != 0;
    const showClientFX = hasDifferentCurrencies && currentDay.ExecutionsAvgFX != 0;

    const originalPrice =
      currentDay.ExecutionsAvgPrice != 0 ? currentDay.ExecutionsAvgPrice : order.OrderPrice;

    const originalFX = currentDay.ExecutionsAvgFX;

    return (
      <div>
        {/* ##### Quantity ###### */}
        {!modHiddens.Quantity && (
          <Field label={quantityTitle} error={errors.Quantity}>
            <Numeric
              value={Quantity}
              placeholder={"Quantity"}
              disabled={modReadonly.Quantity}
              onChange={(v) => onChange({ Quantity: v })}
              invalid={!!errors.Quantity}
              dataTypeDecimalName="quantity"
            />
          </Field>
        )}

        {/* ##### Account ###### */}
        <FormGroup>
          <Field label="Account" error={errors.AccountName}>
            <Autosuggest
              renderSuggestion={renderSuggestion}
              getSuggestionValue={getSuggestionValue}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              value={AccountNumber ? `${AccountNumber} - ${AccountName}` : ""}
              inputProps={inputProps}
              onChange={this.onChange}
            />
          </Field>
        </FormGroup>

        {this.state.loadingHolders ? (
          <CircularProgress sm />
        ) : (
          <div>
            {!hideHolders && (
              <Field label="Holder" error={errors.HolderName}>
                <Holders
                  name={HolderName}
                  value={HolderId}
                  items={this.state.holders}
                  disabled={modReadonly.HolderName || modReadonly.AccountName}
                  invalid={!!errors.HolderName}
                  onChange={this.onChangeAccountHolder}
                />
              </Field>
            )}
            {this.state.loadingBalance ? (
              <CircularProgress sm />
            ) : (
              balanceReady && this.state.balance != null && <Balance balance={this.state.balance} />
            )}
            {!hideHolders && (
              <Instruction
                value={account.Instruction}
                items={this.state.instructions}
                attachmentDisabled={attachmentDisabled}
                userType={userType}
                disabled={modReadonly.Instruction || HolderId == null}
                error={errors.Instruction}
                onChange={this.onChangeInstruction}
                onChangeOrder={onChange}
                setAttachment={this.onSetAttachment}
                downloadAttachment={downloadAttachment}
                orderId={OrderId}
                orderPdf={orderPdf}
                hasAttachment={hasAttachment}
                accountId={AccountId}
                canResend={canResend}
                hasFile={account.HasFile}
                onResendAuth={this.onResendAuth}
                sendingMail={this.state.sendingMail}
              />
            )}
          </div>
        )}
        {/* ##### Custody ###### */}
        {!modHiddens.RequiresSpecialCustody && (
          <Field>
            <Switch
              value={RequiresSpecialCustody || false}
              label={"Custody"}
              disabled={modReadonly.RequiresSpecialCustody}
              onChange={(v) => onChange({ RequiresSpecialCustody: v })}
            />
          </Field>
        )}

        {!(modHiddens.Markup && modHiddens.FXMarkup && modHiddens.Commission) && OrderId > 0 && (
          <div style={{ marginBottom: "10px" }}>
            <u>{earningsTitle}</u>
          </div>
        )}

        {!modHiddens.Markup && (
          <Fragment>
            <Row>
              {/* ##### Mark up/down ###### */}
              <Col lg={6}>
                <Field label={markupTitle} error={errors.Markup}>
                  <Numeric
                    value={Markup}
                    placeholder={`Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                    disabled={modReadonly.Markup}
                    onChange={(v) => onChange({ Markup: v })}
                    invalid={!!errors.Markup}
                    {...commissionSuffix(MarkupType, order.OrderCurrencySymbol)}
                    dataTypeDecimalName="currency"
                  />
                </Field>
              </Col>

              {/* ##### Mark type ###### */}
              <Col lg={6}>
                <Field label={"Type"} error={errors.MarkupType}>
                  <Combobox
                    value={MarkupType}
                    items={getCommissionItems(order.AssetClassForm)}
                    disabled={modReadonly.MarkupType}
                    onChange={(v) => onChange({ MarkupType: v })}
                    emptyLabel={"Type"}
                    invalid={!!errors.MarkupType}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>
            </Row>

            {/* ##### Client Price ###### */}
            {showClientPrice && (
              <Field label={"Client price"}>
                <Numeric
                  value={clientPrice(
                    order.OrderSide,
                    MarkupType,
                    Markup,
                    originalPrice,
                    AssetPriceIsDiscounted
                  )}
                  placeholder={"Client Price"}
                  onChange={(v) => null}
                  disabled
                  dataTypeDecimalName="price"
                />
              </Field>
            )}

            {/* #### FX Mark up/down #### */}
            {!modHiddens.FXMarkup && readonly.FXMarkupAllowed && (
              <Row>
                <Col lg={6}>
                  <Field label={FXMarkupTitle} error={errors.FXMarkup}>
                    <Numeric
                      value={FXMarkup}
                      placeholder={`FX Mark ${order.OrderSide == "Buy" ? "Up" : "Down"}`}
                      disabled={modReadonly.FXMarkup}
                      onChange={(v) => onChange({ FXMarkup: v })}
                      invalid={!!errors.FXMarkup}
                      {...commissionSuffix(FXMarkupType, `${baseCurrency}/${priceCurrency}`)}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                </Col>

                {/* ##### FX Mark type ###### */}
                <Col lg={6}>
                  <Field label={"Type"} error={errors.FXMarkupType}>
                    <Combobox
                      value={FXMarkupType}
                      items={getCommissionItems(order.AssetClassForm)}
                      disabled={modReadonly.FXMarkupType}
                      onChange={(v) => onChange({ FXMarkupType: v })}
                      emptyLabel={"Type"}
                      invalid={!!errors.FXMarkupType}
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                    />
                  </Field>
                </Col>
              </Row>
            )}

            {/* ##### Client Price ###### */}
            {showClientFX && (
              <Field label={"Client FX"}>
                <Numeric
                  value={clientPrice(order.OrderSide, FXMarkupType, FXMarkup, originalFX, false)}
                  placeholder={"Client FX"}
                  onChange={(v) => null}
                  disabled
                  dataTypeDecimalName="currency"
                />
              </Field>
            )}
          </Fragment>
        )}
        {!modHiddens.Commission && (
          <Row>
            {/* ##### Commission ###### */}
            <Col lg={6}>
              <Field label={commissionTitle} error={errors.Commission}>
                <Numeric
                  value={Commission}
                  placeholder={`Commission`}
                  disabled={modReadonly.Commission}
                  onChange={(v) => onChange({ Commission: v })}
                  invalid={!!errors.Commission}
                  {...commissionSuffix(CommissionType, order.OrderSettlementCurrencySymbol)}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.CommissionType}>
                <Combobox
                  value={CommissionType}
                  items={getCommissionItems(order.AssetClassForm)}
                  disabled={modReadonly.CommissionType}
                  invalid={!!errors.CommissionType}
                  onChange={(v) => onChange({ CommissionType: v })}
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const defaultAccountValue = {
  AccountId: null,
  AccountName: "",
  HolderId: null,
  HolderName: null,
  Instruction: null,
};

const renderSuggestion = (suggestion) => (
  <div className={styleF.suggestionItem}>
    {suggestion.number}
    {" - "}
    <span>{suggestion.name}</span>
  </div>
);

const getSuggestionValue = (suggestion) => `${suggestion.number} - ${suggestion.name}`;

const getInstructions = (holder) => {
  const instructions = [];
  if (holder.HoldersOrderNO) instructions.push({ id: "Managed", description: "Managed" });
  else {
    if (holder.HoldersOrderW) instructions.push({ id: "Written", description: "Written" });
    if (holder.HoldersOrderV) instructions.push({ id: "Web", description: "Web" });
    if (holder.HoldersOrderL) instructions.push({ id: "ViaLink", description: "Via Link" });
  }

  return instructions;
};

const getItemById = (items, id) => items.find((e) => e.id === id);

const isEmpty = (value) => value === undefined || value === "";

export default Account;
